import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '5234416',
  title: 'Recado Importante',
  video: { platform: 'youtube', videoId: '_EqGC80FVUU' },
  article: ['Descrição da aula.'],
};
export default lesson;

